export const IconButton = ({ label, onClick, pressed, disabled, children }) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
        aria-pressed={pressed}
        className={`flex h-11 w-11 items-center justify-center rounded-full bg-black/70 text-white shadow-lg shadow-black/40 ring-1 transition disabled:opacity-40 ${
            pressed
                ? "ring-2 ring-white"
                : "ring-white/25 hover:bg-black/90 active:bg-black/90"
        }`}
    >
        {children}
    </button>
)
